<template>
  <div class="table">
    <el-table
      :data="allApprover"
      @selection-change="handleSelectionChange"
      style="width: 100%"
      empty-text=""
      v-loading="tableLoading || loading"
    >
      <div slot="empty">
        <NoDataToView
          v-if="!loading"
          link="/admin/attendance/overtime/settings/approver/create"
          :showButton="showCreateApprover"
          btnText="Approver"
        >
          <template slot="message">
            <p>
              {{ noDataMessage }} &nbsp;<button
                v-if="!showCreateApprover"
                @click="$emit('clear')"
                class="pointer blue underline"
              >
                clear
              </button>
            </p>
          </template>
        </NoDataToView>
      </div>
      <el-table-column type="selection" width="50"></el-table-column>
      <el-table-column prop="id" width="80"></el-table-column>
      <el-table-column
        sortable
        prop="group_name"
        label="Group Name"
      ></el-table-column>
      <el-table-column
        sortable
        prop="approvers_count"
        label="Approver Count"
      ></el-table-column>
      <el-table-column sortable prop="actions" label="ACTIONS">
        <template slot-scope="scope">
          <div class="actions">
            <button @click="viewApprover(scope.row.id)">
              <img src="/img/view.svg" alt="view" />
            </button>
            <button @click="editApprover(scope.row.id)">
              <img src="/img/pencil-edit.svg" alt="edit" />
            </button>
            <button @click="deleteOneApprover(scope.row.id)">
              <img src="/img/delete.svg" alt="delete" />
            </button>
          </div>
        </template>
      </el-table-column>
      <el-table-column width="150">
        <template slot-scope="scope">
          <button
            class="line pointer black"
            @click="assignEmployee(scope.row.id)"
          >
            Assign Employee
          </button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        mini
        @size-change="handleSizeChangeApprover"
        @current-change="handleCurrentChangeApprover"
        :current-page.sync="currentPage"
        :page-sizes="pageSizes"
        :page-size="perPageApprover"
        layout="total, sizes, prev, pager, next, jumper"
        :total="approverTotal"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import NoDataToView from "@/components/general/NoDataToView.vue";
import { createNamespacedHelpers } from "vuex";
const { mapState, mapActions } = createNamespacedHelpers(
  "admin/attendance/overtime"
);

export default {
  components: {
    NoDataToView,
  },
  props: ["allApprover", "searchQuery", "approverTotal"],
  data() {
    return {
      pageSizes: this.$store.state.admin.pageSizes,
      loading: false,
    };
  },
  computed: {
    ...mapState(["tableLoading", "pageApprover", "perPageApprover"]),
    currentPage: {
      get() {
        return this.pageApprover;
      },
      set(value) {
        return this.$store.commit(
          "admin/attendance/overtime/OVERTIME_MUTATIONS",
          {
            key: "pageApprover",
            value,
          }
        );
      },
    },
    showCreateApprover() {
      return !this.allApprover.length && !this.searchQuery;
    },
    noDataMessage() {
      let message = `You are yet to create any approver`;
      if (this.showCreateApprover) {
        return message;
      }
      if (this.searchQuery !== "") {
        return `${message} ${this.searchQuery ? "for " : ""} ${
          this.searchQuery
        } `;
      }
      return `${message}`;
    },
  },
  methods: {
    ...mapActions([
      "deleteApprover",
      "getAllApprovers",
      "handleSizeChangeApprover",
      "handleCurrentChangeApprover",
    ]),
    handleSelectionChange(val) {
      this.$emit("handleSelectionChange", val);
    },
    editApprover(id) {
      this.$router.push(
        `/admin/attendance/overtime/settings/approver/edit/${id}`
      );
    },
    deleteOneApprover(id) {
      this.$promptModal(
        "Delete Approver",
        "Are you sure you want to delete the selected approver?",
        "Yes, Delete",
        () => this.handleDeleteApprover(id)
      );
    },
    handleDeleteApprover(id) {
      this.loading = true;
      this.deleteApprover(id)
        .then(() => {
          this.loading = false;
          this.getAllApprovers();
        })
        .catch(() => {
          this.loading = false;
        });
    },
    viewApprover(id) {
      this.$router.push({
        name: "view-approver-settings",
        params: { id },
      });
    },
    assignEmployee(id) {
      this.$router.push({
        name: "assign-employee-approver",
        params: { id },
      });
    },
  },
};
</script>
